export const PROPS = {
  disclaimerTitle: {
    text: 'Before proceeding, please read the following disclaimer:',
    className: 'text-style-g-em text-neutral-700 mb-4',
    skeletonProps: {
      width: 280,
    },
  },
  disclaimer: {
    text: 'Have you been made aware that this loan is for the purchase your Panels (battery) and is not set off by any savings you make from your product, so the Credit Agreement stands alone from any energy savings, which means that this loan is to be repaid, irrespective of savings',
    className: 'text-14-22-em text-neutral-700',
    skeletonProps: {
      width: 280,
      count: 5,
    },
  },
};

export const CLASS_NAMES = {
  disclaimer: 'px-4 py-3 border border-neutral-300 rounded rounded-lg mb-10',
};

export const HEADER_CLASS_NAMES = {
  container: 'flex w-full flex-col mb-6',
  descriptionWrapper: 'flex flex-1 w-full flex-row items-center',
  title: 'block text-style-e text-neutral-900 mb-4',
  description: 'w-full text-style-g text-neutral-700 mr-6',
  icon: 'flex-none',
};

export const HEADER_PROPS = {
  title: {
    text: 'This loan is to pay for your renewable home improvements. Please read the disclaimer before applying',
    className: HEADER_CLASS_NAMES.title,
    skeletonProps: {
      count: 2,
    },
  },
  description: {
    text: "Kanda is a credit broker and loans are provided through Omni Capital Retail Finance, part of Castle Trust Bank. So you are in good hands. We'll help you complete your application.",
    className: HEADER_CLASS_NAMES.description,
    skeletonProps: {
      count: 4,
    },
  },
  icon: {
    size: 48,
    icon: 'shield-check',
    stroke: 'purple-200',
    className: HEADER_CLASS_NAMES.icon,
  },
};

export const FIELD_NAMES = ['acceptedDisclaimer', 'acceptedStandAlone'];

export const FIELDS = [
  {
    fieldName: FIELD_NAMES[0],
    label: 'I have read and understood the above disclaimer',
    validationMessage:
      'You must have read, understood and agree to the above disclaimer',
  },
  {
    fieldName: FIELD_NAMES[1],
    label:
      'I accept that the Credit Agreement stands alone from any energy savings',
    validationMessage:
      'You must accept that the Credit Agreement stands alone from any energy savings',
  },
];
